// Pure helpers for the manual position entry modal
// (components/modals/manual-position-modal.tsx).

export interface ChainOptionQuote {
  strike: number;
  bid: number;
  ask: number;
}

/** Flatten /api/options/chain response chains into a single option list. */
export function flattenChainOptions(
  chains: Array<{ options?: ChainOptionQuote[] }> | undefined | null,
): ChainOptionQuote[] {
  if (!chains) return [];
  const out: ChainOptionQuote[] = [];
  for (const chain of chains) {
    for (const opt of chain.options || []) out.push(opt);
  }
  return out;
}

/**
 * Find the option at the given strike (within a cent) and return its mid
 * price. Falls back to bid or ask alone when one side is missing.
 * Returns null when there is no match or no usable price.
 */
export function findOptionMid(
  options: ChainOptionQuote[],
  strike: number,
): number | null {
  if (!Number.isFinite(strike)) return null;
  const match = options.find((opt) => Math.abs(opt.strike - strike) < 0.01);
  if (!match) return null;
  const mid =
    match.bid > 0 && match.ask > 0
      ? (match.bid + match.ask) / 2
      : match.bid || match.ask || 0;
  return mid > 0 ? mid : null;
}

export interface PositionLabelInput {
  symbol: string;
  isOption: boolean;
  side: "long" | "short";
  optionType?: "CALL" | "PUT";
  strike?: number;
  expiration?: string;
  units: number;
}

export function formatPositionLabel(pos: PositionLabelInput): string {
  if (pos.isOption) {
    return `${pos.symbol} ${pos.side === "short" ? "-" : ""}${pos.units}x $${pos.strike}${pos.optionType === "CALL" ? "C" : "P"} ${pos.expiration}`;
  }
  return `${pos.symbol} ${pos.side === "short" ? "-" : ""}${pos.units} shares`;
}
